import { render, staticRenderFns } from "./ButtonNav.vue?vue&type=template&id=97860ece&scoped=true&"
import script from "./ButtonNav.vue?vue&type=script&lang=ts&"
export * from "./ButtonNav.vue?vue&type=script&lang=ts&"
import style0 from "./ButtonNav.vue?vue&type=style&index=0&id=97860ece&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97860ece",
  null
  
)

export default component.exports